import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "virtualRef",
  class: "form-control user-select-none cursor-text form-control h-40px d-flex align-items-center position-relative"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElementPlusClearIcon = _resolveComponent("ElementPlusClearIcon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_RangeTab = _resolveComponent("RangeTab")!
  const _component_WeeksTab = _resolveComponent("WeeksTab")!
  const _component_MonthsTab = _resolveComponent("MonthsTab")!
  const _component_YearsTab = _resolveComponent("YearsTab")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        readonly: "",
        placeholder: "Select Dates",
        type: "text",
        class: "pt-1 w-100 pseudo-input fs-6 text-dark"
      }, null, 512), [
        [_vModelText, _ctx.value]
      ]),
      (_ctx.value != '')
        ? (_openBlock(), _createBlock(_component_ElementPlusClearIcon, {
            key: 0,
            onClick: _ctx.handleClear,
            style: {"right":"15px"},
            class: _normalizeClass(
        `position-absolute cursor-pointer opacity-${
          _ctx.value == '' ? '0' : '25'
        } opacity-100-hover`
      )
          }, null, 8, ["onClick", "class"]))
        : _createCommentVNode("", true)
    ], 512),
    (_openBlock(), _createBlock(_component_el_popover, {
      key: _ctx.popoverKey,
      ref: "popoverRef",
      trigger: "click",
      "virtual-ref": _ctx.virtualRef,
      class: "w-100",
      width: "450",
      "virtual-triggering": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
            size: `medium`,
            class: "w-100 d-flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "Range" }),
              _createVNode(_component_el_radio_button, { label: "Weeks" }),
              _createVNode(_component_el_radio_button, { label: "Months" }),
              _createVNode(_component_el_radio_button, { label: "Years" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_3,
          (_ctx.tab == 'Range')
            ? (_openBlock(), _createBlock(_component_RangeTab, {
                key: 0,
                ref: "rangeTab",
                onSelect: _ctx.handleChangeValue
              }, null, 8, ["onSelect"]))
            : _createCommentVNode("", true),
          (_ctx.tab == 'Weeks')
            ? (_openBlock(), _createBlock(_component_WeeksTab, {
                key: 1,
                onSelect: _ctx.handleChangeValue
              }, null, 8, ["onSelect"]))
            : _createCommentVNode("", true),
          (_ctx.tab == 'Months')
            ? (_openBlock(), _createBlock(_component_MonthsTab, {
                key: 2,
                onSelect: _ctx.handleChangeValue
              }, null, 8, ["onSelect"]))
            : _createCommentVNode("", true),
          (_ctx.tab == 'Years')
            ? (_openBlock(), _createBlock(_component_YearsTab, {
                key: 3,
                onSelect: _ctx.handleChangeValue
              }, null, 8, ["onSelect"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["virtual-ref"]))
  ], 64))
}